import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AvatarLatencyInputMode, AvatarLatencyProvider, AvatarLatencySummary, GlobalStat, UsageStat } from '@shared/index';
import dayjs from 'dayjs';
import { firstValueFrom } from 'rxjs';
import { BotService } from 'src/app/shared/services/bot.service';
import { RagLoggerService } from '@shared-angular/services/rag-logger/rag-logger.service';
import { DebugSocketService } from 'src/app/shared/services/debug-socket.service';
import { Month } from './statistics-month-selector/statistics-month-selector.component';

@Injectable({
  providedIn: 'root'
})
export class StatisticService {
  public debugBotId: string = "";
  public debugUserId: string = "";
  public debugLog: GlobalStat[] = [];
  private loopRunning: boolean = false;

  constructor(private http: HttpClient, private debugSocketService: DebugSocketService, botService: BotService, public logger: RagLoggerService) {
    void this.init();
    botService.resetBotDoneEmitter.subscribe(() => {
      this.debugLog.splice(0, this.debugLog.length);
    });
  }

  private async init() {
    // Intentionally left minimal: debug socket is only connected on startDebug()
  }

  public async stopDebug() {
    const io = await this.debugSocketService.getDebugIo();
    io.emit("registerDebug", { register: false }, (_data: unknown) => { });
  }

  public async startDebug(botid: string) {
    this.debugSocketService.connectToDebug(botid);
    const io = await this.debugSocketService.getDebugIo();
    io.on("debugMsg", (data: { stat: GlobalStat }) => {
      data.stat.created = new Date(data.stat.created);
      this.debugLog.push(data.stat);
    });
    // registerDebug must be sent after connection — WsClient drops emits silently
    // when the socket isn't OPEN yet (no buffering). Binding to 'connect' also
    // handles reconnects automatically (room membership is restored).
    const register = () => {
      io.emit("registerDebug", { register: true }, (data: { currentStats: GlobalStat[] }) => {
        data.currentStats.forEach((stat: GlobalStat) => {
          stat.created = new Date(stat.created);
          this.debugLog.push(stat);
        });
      });
    };
    io.on('connect', register);
    if (io.connected) {
      register();
    }
  }

  public async getStatistics(botId: string): Promise<UsageStat[]> {
    return await firstValueFrom(this.http.get<UsageStat[]>("/api/toolbox/stats/get/" + botId));
  }

  public async getAvatarLatency(botId: string, filter: { days: number; provider: AvatarLatencyProvider | null; inputMode: AvatarLatencyInputMode | null }): Promise<AvatarLatencySummary> {
    let params = new HttpParams().set('days', filter.days);
    if (filter.provider) params = params.set('provider', filter.provider);
    if (filter.inputMode) params = params.set('inputMode', filter.inputMode);
    return await firstValueFrom(this.http.get<AvatarLatencySummary>("/api/toolbox/stats/latency/" + botId, { params }));
  }

  public async reportHeygenStat(botId: string, duration_ms: number) {
    return await firstValueFrom(this.http.post<UsageStat[]>(`/api/toolbox/heygen/reportusage/${botId}`, { duration_ms }));
  }
  public getMonth(month: Month): string {
    return dayjs().set("month", month - 1).format('MMMM');
  }
}
